import React from 'react';

const LocationV2Icon = ({ width = '15', height = '20' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="grommet-icons-location">
        <path
          id="Vector"
          d={`M7.54545 19C7.54545 19 1 13.6 1 8.2C1 3.7 4.27273 1 7.54545 1C10.8182 1 14.0909 3.7 
        14.0909 8.2C14.0909 13.6 7.54545 19 7.54545 19ZM7.54545 10.9C8.90118 10.9 10 9.6913 10 8.2C10 6.7087 8.90118 
        5.5 7.54545 5.5C6.18973 5.5 5.09091 6.7087 5.09091 8.2C5.09091 9.6913 6.18973 10.9 7.54545 10.9Z`}
          stroke="currentColor"
        />
      </g>
    </svg>
  );
};

export default LocationV2Icon;
